import React from "react";
import { IoIosArrowRoundForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
const HeadingCom = (props) => {
    const navigate = useNavigate();
    return (
        <div className="flex justify-between items-center w-full">
            <h2 className={`xs:text-sm sm:text-base lg:text-xl uppercase font-onestSemiBold text-secondary ${props.navigatelayout}`} >{props.title}</h2>
            <div className={`text-secondary font-onestRegular xs:text-xs sm:text-sm lg:text-base flex items-center group hover:text-orangeCrayola ${props.to ? 'cursor-pointer' : 'cursor-default'}`} onClick={() => props.to ? navigate(props.to) : null}>View More <IoIosArrowRoundForward className="text-secondary sm:text-3xl ransition-all duration-300 -rotate-45 group-hover:rotate-0 group-hover:text-orangeCrayola" /></div>
        </div>
    )
}
export default HeadingCom;